import { render, staticRenderFns } from "./edit_popup_form.vue?vue&type=template&id=6f80df5d&scoped=true&lang=pug&"
import script from "./edit_popup_form.vue?vue&type=script&lang=js&"
export * from "./edit_popup_form.vue?vue&type=script&lang=js&"
import style0 from "./edit_popup_form.vue?vue&type=style&index=0&id=6f80df5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80df5d",
  null
  
)

export default component.exports